import {
  ColorIcon,
  colors,
  customEvent,
  getCdnImageSrc,
  HStack,
  NextLink,
  responsive,
  Spacing,
  VStack,
} from "goi_common";
import { useOverlay } from "@toss/use-overlay";
import { Box } from "@chakra-ui/react";
import FileRequestModal from "@/containers/Parlor/ParlorDetailContainer/components/Modal/FileRequestModal";
import { useRouter } from "next/router";
import {
  FuneralPrepareOneBanner,
  FuneralPrepareTwoBanner,
} from "@/containers/HomeContainer/components/RenewalVersion/FuneralPrepareBanner";

export const GuidebookDetailBannerSection = () => {
  const router = useRouter();
  const isCustomBannerRoute = router.asPath === "/guidebook/tip/ongoing/1/";

  return (
    <VStack>
      {isCustomBannerRoute ? (
        <>
          <Spacing gap={40} />
          <FuneralPrepareOneBanner path="gdb_tip" />
          <Spacing gap={12} />
          <FuneralPrepareTwoBanner path="gdb_tip" />
        </>
      ) : (
        <>
          <GuidebookDetailUvMatchRequestBanner />
          <GuidebookDetailChecklistBanner />
        </>
      )}
    </VStack>
  );
};

const GuidebookDetailUvMatchRequestBanner = () => {
  return (
    <NextLink
      href="/match/request/?utm_campaign=guidebook_tip_top_banner"
      event={{
        newGtm: { path: "gdb_tip", trigger_and_target: "banner_CTA-uv_match_request" },
      }}
    >
      <HStack
        css={responsive({
          backgroundImage: {
            base: `url(${getCdnImageSrc(`platform/guidebook/tip_banner_mobile.jpg`)})`,
            lg: `url(${getCdnImageSrc(`platform/guidebook/tip_banner_desktop.jpg`)})`,
          },
          backgroundSize: "cover",
          margin: {
            base: "19px 20px 0px 20px",
            lg: "60px 20px 10px 20px",
          },
          cursor: "pointer",
        })}
        height={116}
        padding="0 16px 0 21px"
        alignItems="center"
        justifyContent="space-between"
        borderRadius={5}
      >
        <VStack>
          <div className="body_14_l white">내 장례식 얼마 나올까?</div>
          <HStack className="subtitle_18_sb white" gap="10px">
            장례 견적 받기
            <Box
              width="24px"
              padding="4px"
              borderRadius="50%"
              background={colors.white}
              css={responsive({
                display: {
                  base: "none",
                  lg: "block",
                },
              })}
            >
              <ColorIcon name="icon-arrow-right-small-mono" color={colors.black} />
            </Box>
          </HStack>
        </VStack>
        <Box
          width="24px"
          padding="4px"
          borderRadius="50%"
          background={colors.white}
          css={responsive({
            display: {
              base: "block",
              lg: "none",
            },
          })}
        >
          <ColorIcon name="icon-arrow-right-small-mono" color={colors.black} />
        </Box>
      </HStack>
    </NextLink>
  );
};

const GuidebookDetailChecklistBanner = () => {
  const overlay = useOverlay();

  return (
    <div
      onClick={() => {
        customEvent({
          newGtm: { path: "gdb_tip", trigger_and_target: "banner_CTA-checklist" },
        });
        overlay.open(({ isOpen, close: onClose }) => {
          return <FileRequestModal path="gdb_tip" isOpen={isOpen} onClose={onClose} />;
        });
      }}
    >
      <HStack
        css={responsive({
          backgroundImage: {
            base: `url(${getCdnImageSrc(`platform/guidebook/tip_banner_mobile.jpg`)})`,
            lg: `url(${getCdnImageSrc(`platform/guidebook/tip_banner_desktop.jpg`)})`,
          },
          backgroundSize: "cover",
          margin: {
            base: "8px 20px 0px 20px",
            lg: "10px 20px 10px 20px",
          },
          cursor: "pointer",
        })}
        height={116}
        padding="0 16px 0 21px"
        alignItems="center"
        justifyContent="space-between"
        borderRadius={5}
      >
        <VStack>
          <div className="body_14_l white">장례 뭘 준비해야 할까?</div>
          <HStack className="subtitle_18_sb white" gap="10px">
            장례 준비 체크리스트
            <Box
              width="24px"
              padding="4px"
              borderRadius="50%"
              background={colors.white}
              css={responsive({
                display: {
                  base: "none",
                  lg: "block",
                },
              })}
            >
              <ColorIcon name="icon-arrow-right-small-mono" color={colors.black} />
            </Box>
          </HStack>
        </VStack>
        <Box
          width="24px"
          padding="4px"
          borderRadius="50%"
          background={colors.white}
          css={responsive({
            display: {
              base: "block",
              lg: "none",
            },
          })}
        >
          <ColorIcon name="icon-arrow-right-small-mono" color={colors.black} />
        </Box>
      </HStack>
    </div>
  );
};
